import { RegistrationSnapshot } from '../changes/DomainChange';
import {
    DeformableGrid,
    DicomDeformableRegistration,
} from '../dicom/dicomDeformableRegistration';
import { ApprovableRegistration } from './approvableRegistration';

export class DeformableRegistration extends ApprovableRegistration {
    readonly registrationKind = 'deformable' as const;

    constructor(parent: DicomDeformableRegistration) {
        super(
            parent.sourceFrameOfReferenceUid,
            parent.targetFrameOfReferenceUid,
            parent
        );
    }

    public get grid(): DeformableGrid {
        return (this.dicomParent as DicomDeformableRegistration).grid;
    }

    captureSnapshot(): RegistrationSnapshot {
        return { ...this.snapshotFields(), transformRevision: 0 };
    }
}

export function isDeformableRegistration(
    registration: ApprovableRegistration
): registration is DeformableRegistration {
    return registration.registrationKind === 'deformable';
}
